export default "__VITE_ASSET__0cf4b919__"